import React from 'react';
import { Link } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { phoneRegExp, passwordRegExp, cuitRegExp } from '../utils/regExpresions';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const PipeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 8h9a3 3 0 0 1 3 3 3 3 0 0 0 3 3h3"/><circle cx="6" cy="16" r="2"/><path d="M8 16h6"/>
  </svg>
);
const MapPinIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
  </svg>
);
const ClockIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>
  </svg>
);
const ShieldIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
  </svg>
);
const EyeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z"/><circle cx="12" cy="12" r="3"/>
  </svg>
);
const EyeOffIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
    <line x1="1" y1="1" x2="23" y2="23"/>
  </svg>
);

export default function SignUp(props) {
  const [showPass, setShowPass] = React.useState(false);
  const [showConfirm, setShowConfirm] = React.useState(false);
  const [snacks, setSnacks] = React.useState({ existente: false, existenteMsg: '', registrado: false, error: false, sesion: false, disconnected: false });
  const close = (key) => setSnacks(s => ({ ...s, [key]: false }));

  return (
    <div className="ds-auth-shell">
      <div className="ds-auth-body">
        {/* Navy aside */}
        <div className="ds-auth-aside">
          <div className="ds-auth-glow" />
          <div className="ds-brand">
            <div className="ds-brand-mark"><PipeIcon /></div>
            <div className="ds-brand-titles">
              <div className="ds-brand-t1">Oldelval <span className="light">· App Externos</span></div>
              <div className="ds-brand-t2">Portal de <b>Solicitudes de Interferencias</b></div>
            </div>
          </div>
          <div style={{ position: 'relative' }}>
            <h2>Gestioná tus cruces sobre la traza de Oldelval</h2>
            <p>Presentá solicitudes de interferencia, seguí su evaluación técnica y legal, y cargá tu documentación desde un solo lugar.</p>
          </div>
          <div className="ds-auth-feats">
            <div className="ds-auth-feat"><div className="ic"><MapPinIcon /></div><div className="tx"><b>Dibujá la interferencia</b><span>Mapa, KML/KMZ y coordenadas DMS.</span></div></div>
            <div className="ds-auth-feat"><div className="ic"><ClockIcon /></div><div className="tx"><b>Seguí el estado en vivo</b><span>Sabé en qué etapa está cada solicitud.</span></div></div>
            <div className="ds-auth-feat"><div className="ic"><ShieldIcon /></div><div className="tx"><b>Documentación segura</b><span>Técnica, legal y CAO en un flujo guiado.</span></div></div>
          </div>
        </div>

        {/* Form column */}
        <div className="ds-auth-form-col">
          <div className="ds-auth-form" style={{ maxWidth: 440 }}>
            <h1>Crear cuenta</h1>
            <div className="ds-auth-sub">Registrá tu empresa para presentar solicitudes.</div>
            <Formik
              initialValues={{ razonSocial: '', nombre: '', cuit: '', direccion: '', numero: '', email: '', contraseña: '', confirmarContraseña: '' }}
              validationSchema={Yup.object().shape({
                razonSocial: Yup.string().max(255).required('Razón social obligatoria'),
                nombre: Yup.string().max(255).required('Nombre y apellido obligatorio'),
                cuit: Yup.string().matches(cuitRegExp, 'CUIL/CUIT no válido').required('CUIL/CUIT obligatorio'),
                direccion: Yup.string().max(255).required('Dirección obligatoria'),
                numero: Yup.string().matches(phoneRegExp, 'Teléfono no válido').required('Teléfono obligatorio'),
                email: Yup.string().email('Email no válido').max(255).required('Email obligatorio'),
                contraseña: Yup.string().required('Contraseña obligatoria').matches(passwordRegExp, 'Mín. 8 caracteres, 1 mayúscula, 1 minúscula y 1 número'),
                confirmarContraseña: Yup.string().oneOf([Yup.ref('contraseña'), null], 'Las contraseñas no coinciden').required('Confirmación obligatoria'),
              })}
              onSubmit={async (data) => {
                await fetch(process.env.REACT_APP_API_ROOT + process.env.REACT_APP_API_REGISTER, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    cuit_cuil: data.cuit, razon_social: data.razonSocial,
                    nombre_apellido: data.nombre, direccion_comercial: data.direccion,
                    email: data.email, direccion_particular: data.direccion,
                    telefono: data.numero, password: data.contraseña,
                  }),
                }).then(result => {
                  if (result.ok) {
                    setSnacks(s => ({ ...s, registrado: true }));
                    setTimeout(() => props.history.push('/'), 1000);
                  } else {
                    result.json().then(d => {
                      if (d.error?.includes('Ya existe') || d.error?.includes('registro en curso')) setSnacks(s => ({ ...s, existente: true, existenteMsg: d.error }));
                      else setSnacks(s => ({ ...s, error: true }));
                    }).catch(() => setSnacks(s => ({ ...s, error: true })));
                  }
                }).catch(() => setSnacks(s => ({ ...s, disconnected: true })));
              }}
            >
              {({ errors, handleSubmit, touched, values, handleChange, handleBlur }) => (
                <form onSubmit={handleSubmit}>
                  <div className="ds-form-rows">
                    <div className="ds-field">
                      <label>Razón Social <span className="req">*</span></label>
                      <input className={`ds-input${touched.razonSocial && errors.razonSocial ? ' err' : ''}`} name="razonSocial" placeholder="Construcciones del Comahue S.R.L." onChange={e => values.razonSocial = e.target.value} onBlur={handleBlur} />
                      {touched.razonSocial && errors.razonSocial && <div className="ds-helper err">{errors.razonSocial}</div>}
                    </div>
                    <div className="ds-grid-2">
                      <div className="ds-field">
                        <label>Nombre y Apellido <span className="req">*</span></label>
                        <input className={`ds-input${touched.nombre && errors.nombre ? ' err' : ''}`} name="nombre" placeholder="Responsable" onChange={e => values.nombre = e.target.value} onBlur={handleBlur} />
                        {touched.nombre && errors.nombre && <div className="ds-helper err">{errors.nombre}</div>}
                      </div>
                      <div className="ds-field">
                        <label>CUIL / CUIT <span className="req">*</span></label>
                        <input className={`ds-input${touched.cuit && errors.cuit ? ' err' : ''}`} name="cuit" placeholder="30-00000000-0" onChange={e => values.cuit = e.target.value} onBlur={handleBlur} />
                        {touched.cuit && errors.cuit && <div className="ds-helper err">{errors.cuit}</div>}
                      </div>
                    </div>
                    <div className="ds-field">
                      <label>Dirección <span className="req">*</span></label>
                      <input className={`ds-input${touched.direccion && errors.direccion ? ' err' : ''}`} name="direccion" placeholder="Calle, número, localidad" onChange={e => values.direccion = e.target.value} onBlur={handleBlur} />
                      {touched.direccion && errors.direccion && <div className="ds-helper err">{errors.direccion}</div>}
                    </div>
                    <div className="ds-grid-2">
                      <div className="ds-field">
                        <label>Teléfono <span className="req">*</span></label>
                        <input className={`ds-input${touched.numero && errors.numero ? ' err' : ''}`} name="numero" placeholder="+54 299 …" onChange={e => values.numero = e.target.value} onBlur={handleBlur} />
                        {touched.numero && errors.numero && <div className="ds-helper err">{errors.numero}</div>}
                      </div>
                      <div className="ds-field">
                        <label>Correo electrónico <span className="req">*</span></label>
                        <input className={`ds-input${touched.email && errors.email ? ' err' : ''}`} name="email" type="email" placeholder="contacto@empresa.com" onChange={e => values.email = e.target.value} onBlur={handleBlur} />
                        {touched.email && errors.email && <div className="ds-helper err">{errors.email}</div>}
                      </div>
                    </div>
                    <div className="ds-grid-2">
                      <div className="ds-field">
                        <label>Contraseña <span className="req">*</span></label>
                        <div className="ds-input-wrap">
                          <input className={`ds-input${touched.contraseña && errors.contraseña ? ' err' : ''}`} name="contraseña" type={showPass ? 'text' : 'password'} placeholder="••••••••" onChange={e => { handleChange(e); values.contraseña = e.target.value; }} onBlur={handleBlur} />
                          <button type="button" className="ds-input-trail" onClick={() => setShowPass(v => !v)}>{showPass ? <EyeOffIcon /> : <EyeIcon />}</button>
                        </div>
                        {touched.contraseña && errors.contraseña && <div className="ds-helper err">{errors.contraseña}</div>}
                      </div>
                      <div className="ds-field">
                        <label>Confirmar <span className="req">*</span></label>
                        <div className="ds-input-wrap">
                          <input className={`ds-input${touched.confirmarContraseña && errors.confirmarContraseña ? ' err' : ''}`} name="confirmarContraseña" type={showConfirm ? 'text' : 'password'} placeholder="••••••••" onChange={e => { handleChange(e); values.confirmarContraseña = e.target.value; }} onBlur={handleBlur} />
                          <button type="button" className="ds-input-trail" onClick={() => setShowConfirm(v => !v)}>{showConfirm ? <EyeOffIcon /> : <EyeIcon />}</button>
                        </div>
                        {touched.confirmarContraseña && errors.confirmarContraseña && <div className="ds-helper err">{errors.confirmarContraseña}</div>}
                      </div>
                    </div>
                    <div className="ds-helper">Mín. 8 caracteres, 1 mayúscula, 1 minúscula y 1 número.</div>
                    <button type="submit" className="ds-btn ds-btn-primary ds-btn-block ds-btn-lg">Crear cuenta</button>
                  </div>
                </form>
              )}
            </Formik>
            <div className="ds-auth-links" style={{ justifyContent: 'center', gap: 6, marginTop: 16 }}>
              <span style={{ color: 'var(--ink-3)' }}>¿Ya tenés cuenta?</span>
              <Link to="/">Iniciá sesión</Link>
            </div>
          </div>
        </div>
      </div>

      <Snackbar open={snacks.existente} autoHideDuration={6000} onClose={() => close('existente')}>
        <Alert severity="warning">{snacks.existenteMsg || 'Ya existe un usuario con ese CUIT/CUIL o email.'}</Alert>
      </Snackbar>
      <Snackbar open={snacks.registrado} autoHideDuration={4000} onClose={() => close('registrado')}>
        <Alert severity="success">Cuenta creada exitosamente. Redirigiendo…</Alert>
      </Snackbar>
      <Snackbar open={snacks.error} autoHideDuration={6000} onClose={() => close('error')}>
        <Alert severity="error">Error al crear la cuenta. Intentá de nuevo.</Alert>
      </Snackbar>
      <Snackbar open={snacks.disconnected} autoHideDuration={6000} onClose={() => close('disconnected')}>
        <Alert severity="error">Sin conexión con el servidor.</Alert>
      </Snackbar>
    </div>
  );
}
